import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toastify } from "../components/Toast";
import { toast, ToastContainer } from "react-toastify";
import * as authActions from "../redux/actions/authAction";
import TextInterface from "../components/TextInterface";
import { socket } from "../constants/socket";

const TextClient = () => {
  const { user } = useSelector((state) => state?.authentication);
  // const [loader, setLoader] = useState(false);
  // const [page, setPage] = useState(1);
  // const limit = 10;
  const dispatch = useDispatch();
  const { coachClientsData } = useSelector((state) => state.getClientsData);
  const { allSmsData, outgoingSmsData } = useSelector(
    (state) => state.getSmsData
  );

  const fetchAllTexts = () => {
    try {
      dispatch(authActions.getAllTexts());
    } catch (error) {
      console.error("Error fetching texts: ", error);
    }
  };

  useEffect(() => {
    fetchAllTexts();
  }, [coachClientsData?.data]);

  useEffect(() => {
    fetchAllTexts();
  }, [outgoingSmsData]);

  useEffect(() => {
    socket.on("new-sms", fetchAllTexts());
    return () => {
      socket.off("new_sms", fetchAllTexts());
    };
  }, []);

  return (
    <>
      <ToastContainer />
      <div className="chat-coach user-profile">
        <div
          style={{ width: "100%", display: "flex", alignContent: "flex-start" }}
        >
          <div
            className="chat-client-header"
            style={{ justifyContent: "space-between" }}
          >
            <h1>Text Messages</h1>
          </div>
        </div>
        <div className="row">
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <TextInterface
              textData={allSmsData.data}
              clientData={coachClientsData.data}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default TextClient;
